import { useWorkspaceContext } from "../state/workspaceContext";
import { useUser } from "./useUser";

export function useCanManageBilling() {
    const user = useUser();
    const { activeWorkspace } = useWorkspaceContext();

    return activeWorkspace?.primaryAdminUserId === user.id;
}
